import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'

class SortingHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: props.name
        };
    }
    _onClick(event){
        this.setState({
            selected: event.target.name
        })

    }

    render() {
        return (
            <Flex width='100%' shrink={0} className={style.Sorting} center basis='70px'>
                <Flex width='20%' center name='issueId'>Ärende</Flex>
                <Flex width='20%' center name='customerId'>Besökare</Flex>
                <Flex width='20%' center name='employee'>Medarbetare</Flex>
                <Flex width='20%' center name='create'>Skapat</Flex>
                <Flex width='20%' center name='finish'>Avklarat</Flex>
            </Flex>
        )

    }


}


export default SortingHeader;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/History/SortingHeader.js